import { Card, Heading, Stack, Text } from '@backyard-ui/core';

import { Image } from '@/presenters/components/common/Image';

import { AlertIcon, BookIcon, FSCIcon, ToolIcon, WarrantIcon } from '../icons';
import { type ItemProps } from '../Item';

import { styles } from './Content.styles';

const ICONS = {
  fispq: <AlertIcon />,
  'installation-guide': <ToolIcon />,
  'user-manual': <BookIcon />,
  fsc: <FSCIcon />,
  warrant: <WarrantIcon />,
  'technical-specification': <BookIcon />,
};

interface ContentProps extends Pick<ItemProps, 'type' | 'title'> {
  isDownloadable: boolean;
}

export default function Content(props: Readonly<ContentProps>) {
  const { type, title, isDownloadable } = props;

  const classNames = styles({ variant: 'default' });

  const getDescription = () => {
    if (type === 'warrant') {
      return 'Garantimos a venda e entrega pela nossa loja parceira. Saiba mais.';
    }

    if (isDownloadable) {
      return 'Clique para Baixar';
    }

    return '';
  };

  return (
    <Card.Root UNSAFE_className={classNames.wrapper()}>
      <Stack align="center" spacing="1">
        {type === 'army-certificate' && (
          <div className={classNames.image()}>
            <Image
              height={48}
              width={48}
              alt="exercito"
              src="/assets/images/exercito.png"
            />
          </div>
        )}

        {type !== 'army-certificate' && (
          <div className={classNames.image({ variant: 'green' })}>
            {ICONS[type]}
          </div>
        )}

        <Card.Body>
          <Stack direction="column" spacing="1">
            <Heading size="sm" asChild>
              <div role="heading" aria-level={1}>
                {title}
              </div>
            </Heading>

            <Text color="gray-900" size="md">
              {getDescription()}
            </Text>
          </Stack>
        </Card.Body>
      </Stack>
    </Card.Root>
  );
}
